<template>
  <jz-container class="learning-history-progress-item">
    <jz-container class="title">
      <span class="description">
        <span class="text">
          {{ title }}
        </span>

        <jz-tooltip :open="tooltipOpen" direction="top">
          <template #tooltip>
            {{ tooltip }}
          </template>

          <jz-icon
            :src="icons.help"
            @mouseenter="tooltipOpen = true"
            @mouseleave="tooltipOpen = false"
          />
        </jz-tooltip>
      </span>

      <span class="value">{{ value }} {{ units }}</span>
    </jz-container>

    <progress :min="0" :max="100" :value="percentage" />
  </jz-container>
</template>

<script>
import Vue from "vue";

import iconHelp from "@joyz/app-core/assets/icons/transparent/Help.svg";
import { roundToDecimal } from "@tt-app/utils";

export default Vue.extend({
  name: "LearningHistoryProgressItem",
  props: {
    item: { type: Object, required: true },
    title: { type: String, required: true },
    tooltip: { type: String, required: true },
    units: { type: String, default: "" }
  },
  data() {
    return {
      icons: {
        help: iconHelp
      },
      tooltipOpen: false
    };
  },
  computed: {
    percentage() {
      if (!this.item.value) {
        return 0;
      }

      const scale = [...this.item.scale].sort((a, b) => a - b);
      const value = this.item.value;

      const percentage = ((value - scale[0]) / (scale[1] - scale[0])) * 100;

      if (this.item.scale[1] < this.item.scale[0]) {
        return 100 - percentage;
      }

      return percentage;
    },
    value() {
      if (!this.item.value) {
        return 0;
      }
      return roundToDecimal(this.item.value, 1);
    }
  }
});
</script>

<style lang="scss">
.learning-history-progress-item {
  .title {
    display: flex;
    justify-content: space-between;

    .description {
      align-items: center;
      color: var(--color-dark);
      display: inline-flex;
      font-size: $font-size-sm;
      font-weight: bold;

      .text {
        margin: 0 ($gutter / 2) 0 0;
      }

      .jz-icon {
        height: $icon-size-xs;
      }

      .jz-tooltip {
        height: $icon-size-xs;

        .tooltip-content {
          font-size: $font-size-xs;
          font-weight: 500;
        }
      }
    }
  }

  .value {
    color: var(--color-dark);
  }

  progress {
    background-color: var(--color-primary-alternate-background-light);
    border: none;
    border-radius: 8px;
    height: 12px;
    width: 100%;

    &::-webkit-progress-bar {
      background-color: var(--color-primary-alternate-background-light);
      border-radius: 8px;
      overflow: hidden;
    }

    &::-moz-progress-bar {
      background-color: var(--color-primary-alternate);
      border-radius: 8px;
    }

    &::-webkit-progress-value {
      background-color: var(--color-primary-alternate);
    }
  }

  .ticks {
    color: var(--color-secondary);
    display: flex;
    font-size: $font-size-xs;
    font-weight: bold;
    justify-content: space-between;
  }
}

@include responsive(tablet) {
  .learning-history-progress-item {
    .title {
      .description {
        .jz-tooltip {
          .tooltip-content {
            display: inline-table;
            width: max-content;
            word-break: keep-all;
          }
        }
      }
    }
  }
}
</style>
